import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="signatures"
// NOTE: we still need jquery as a dependency of this controller since jsignature is a jquery plugin. bummer
export default class extends Controller {
  static targets = [
    "signature",
    "signatureSvgBase64",
    "signatureNeeded",

    // Allow these elements to be optional.  Instead of defining them as targets,
    // look for them in connect().
    // "includeSpouseSignature",
    // "spouseSignatureContainer",
    // "spouseSignature",
    // "spouseSignatureSvgBase64",
    // "spouseSignatureNeeded",  
  ];

  connect() {
    $(this.signatureTarget).jSignature({ height: '200', width: '100%' })
    $(this.signatureTarget).on('change', this.addSvgToForm.bind(this))

    // This is a way to get the targets when they exist, and otherwise ignore them.
    this.includeSpouseSignatureTarget = this.element.querySelector('[data-signatures-target="includeSpouseSignature"]');
    this.spouseSignatureContainerTarget = this.element.querySelector('[data-signatures-target="spouseSignatureContainer"]');
    this.spouseSignatureTarget = this.element.querySelector('[data-signatures-target="spouseSignature"]');
    this.spouseSignatureSvgBase64Target = this.element.querySelector('[data-signatures-target="spouseSignatureSvgBase64"]');
    this.spouseSignatureNeededTarget = this.element.querySelector('[data-signatures-target="spouseSignatureNeeded"]');

    if (this.includeSpouseSignatureTarget && this.includeSpouseSignatureTarget.value === "true") {
      $(this.spouseSignatureTarget).jSignature({ height: '200', width: '100%' })
      $(this.spouseSignatureTarget).on('change', this.addSpouseSvgToForm.bind(this))
    }
  }

  addSvgToForm(event) {
    var svgData = $(this.signatureTarget).jSignature("getData", "svgbase64")
    this.signatureSvgBase64Target.value = svgData
    // this doesn't necessarily trigger a change on the hidden element, so do it manually
    this.signatureSvgBase64Target.dispatchEvent(new Event("change"))
  }

  addSpouseSvgToForm(event) {
    var svgData = $(this.spouseSignatureTarget).jSignature("getData", "svgbase64")
    this.spouseSignatureSvgBase64Target.value = svgData
    // this doesn't necessarily trigger a change on the hidden element, so do it manually
    this.spouseSignatureSvgBase64Target.dispatchEvent(new Event("change"))
  }

  clearSignature() {
    $(this.signatureTarget).jSignature("reset")
    this.signatureSvgBase64Target.value = ""
    //this.signatureNeededTarget.classList.add("hidden");
  }

  clearSpouseSignature() {
    $(this.spouseSignatureTarget).jSignature("reset")
    this.spouseSignatureSvgBase64Target.value = ""
    //this.spouseSignatureNeededTarget.classList.add("hidden");
  }

  onHaveSpouseChange(e) {
    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size.  To make this happen
    // We use an arbitrarily large max-height which should be big enough to accommodate the content.
    this.spouseSignatureContainerTarget.classList.toggle("max-h-0");
    this.spouseSignatureContainerTarget.classList.toggle("max-h-[1000px]");
  }

  onSubmit(e) {
    e.preventDefault();
    // Ensure the user signed (avoid empty signatures)
    var data = $(this.signatureTarget).jSignature("getData", "native");
    // The returned value is an array of strokes.  If it's empty, it means the user didn't sign at all.
    // https://willowsystems.github.io/jSignature/#/about/
    if (data.length == 0) {
      this.signatureNeededTarget.classList.remove("hidden");
      this.signatureNeededTarget.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    } else {
      this.signatureNeededTarget.classList.add("hidden");
      this.addSvgToForm(e);
    }

    if (this.includeSpouseSignatureTarget && this.includeSpouseSignatureTarget.value === "true" && this.element['have_spouse'] && this.element['have_spouse'].checked) {
      // Ensure the spouse signed too (avoid empty signatures)
      var data = $(this.spouseSignatureTarget).jSignature("getData", "native");
      if (data.length == 0) {
        this.spouseSignatureNeededTarget.classList.remove("hidden");
        this.spouseSignatureNeededTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      } else {
        this.spouseSignatureNeededTarget.classList.add("hidden");
        this.addSpouseSvgToForm(e);
      }
    }

    this.element.submit();
  }
}
